import * as React from "react";

const StickerIosIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#858E99"
      fillRule="evenodd"
      d="M7.662.516c1.6 0 7.793 6.205 7.853 7.685-.196 3.909-3.42 7.094-7.379 7.094A7.396 7.396 0 0 1 .74 7.899C.74 4.022 3.866.829 7.662.516ZM7.08 1.698a6.288 6.288 0 1 0 7.253 7.254l.046-.02A5.547 5.547 0 0 1 7.005 1.89l.076-.19Zm1.064.334.098-.207.096.048c.132.07.285.16.452.269.693.45 1.486 1.252 2.332 2.106a161.428 161.428 0 0 0 .675.679c.847.847 1.63 1.63 2.076 2.324.135.21.24.397.313.55a4.438 4.438 0 0 1-6.042-5.769Z"
      clipRule="evenodd"
    />
  </svg>
);
export default StickerIosIcon;
